module.exports = __webpack_public_path__ + "img/28.f47b789f.png";